const BLOCK_SELECTOR = "p, div, h1, h2, h3, h4, h5, h6, li, blockquote, pre, tr";

function htmlToPlainText(html) {
  const container = document.createElement("div");
  container.innerHTML = html;
  container.querySelectorAll("br").forEach(br => br.replaceWith("\n"));
  container.querySelectorAll(BLOCK_SELECTOR).forEach(el => {
    el.insertAdjacentText("afterend", "\n");
  });
  const text = container.textContent || container.innerText || "";
  return text.replace(/\n{3,}/g, "\n\n").replace(/[ \t]+\n/g, "\n").trim();
}

export function createPasteFallbackHandler(value, setValue) {
  return function handlePaste(e) {
    const clipboardData = e.clipboardData;
    if (!clipboardData) return;

    const plain = clipboardData.getData("text/plain");
    if (plain && plain.trim()) return;

    const html = clipboardData.getData("text/html");
    if (!html) return;

    const text = htmlToPlainText(html);
    if (!text) return;

    e.preventDefault();
    const el = e.currentTarget;
    const start = el.selectionStart ?? value.length;
    const end = el.selectionEnd ?? value.length;
    setValue(value.slice(0, start) + text + value.slice(end));
  };
}
